import raf from './raf';
export function getOffset(el) {
    if (!el) {
        return {
            offsetTop: 0,
            offsetLeft: 0,
        };
    }
    var offsetTop = el.clientTop || 0;
    var offsetLeft = el.clientLeft || 0;
    while (el) {
        offsetTop += el.offsetTop || 0;
        offsetLeft += el.offsetLeft || 0;
        el = el.offsetParent;
    }
    return {
        offsetTop: offsetTop,
        offsetLeft: offsetLeft,
    };
}
export var getScrollTop = function (el) {
    return el === window
        ? window.document.body.scrollTop || document.documentElement.scrollTop
        : el.scrollTop;
};
export function hasClass(el, cls) {
    if (!el || !cls)
        return false;
    if (cls.indexOf(' ') !== -1)
        throw new Error('className should not contain space.');
    if (el.classList) {
        return el.classList.contains(cls);
    }
    else {
        return (' ' + el.className + ' ').indexOf(' ' + cls + ' ') > -1;
    }
}
/* istanbul ignore next */
export function addClass(el, cls) {
    if (!el)
        return;
    var curClass = el.className;
    var classes = (cls || '').split(' ');
    for (var i = 0, j = classes.length; i < j; i++) {
        var clsName = classes[i];
        if (!clsName)
            continue;
        if (el.classList) {
            el.classList.add(clsName);
        }
        else if (!hasClass(el, clsName)) {
            curClass += ' ' + clsName;
        }
    }
    if (!el.classList) {
        el.className = curClass;
    }
}
/* istanbul ignore next */
var trim = function (string) {
    return (string || '').replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, '');
};
/* istanbul ignore next */
export function removeClass(el, cls) {
    if (!el || !cls)
        return;
    var classes = cls.split(' ');
    var curClass = ' ' + el.className + ' ';
    for (var i = 0, j = classes.length; i < j; i++) {
        var clsName = classes[i];
        if (!clsName)
            continue;
        if (el.classList) {
            el.classList.remove(clsName);
        }
        else if (hasClass(el, clsName)) {
            curClass = curClass.replace(' ' + clsName + ' ', ' ');
        }
    }
    if (!el.classList) {
        el.className = trim(curClass);
    }
}
export function qs(s) {
    return typeof document !== 'undefined' && document.querySelector(s);
}
export function qsa(s) {
    return typeof document !== 'undefined' && document.querySelectorAll(s);
}
// Return scroll position
export function scroll(ref) {
    var x = ref.pageXOffset || ref.scrollLeft;
    var y = ref.pageYOffset || ref.scrollTop;
    return {
        left: x,
        top: y,
    };
}
// ease easeOutCubic
function easeOutCubic(pos) {
    return Math.pow((pos - 1), 3) + 1;
}
// Scroll to `(x, y)`.
export function scrollTo(x, y, options, callback, container) {
    if (options === void 0) { options = {}; }
    if (callback === void 0) { callback = function () { }; }
    var stop = false;
    if (!container)
        container = window;
    var from = scroll(container);
    // @ts-ignore: Unreachable code error
    var duration = options.duration == 0 ? 0 : options.duration || 1000;
    var start = Date.now();
    // Update position
    function update() {
        var now = Date.now();
        if (now - start >= duration) {
            stop = true;
        }
        // easeOutCubic
        var percent = easeOutCubic((now - start) / duration);
        if (duration == 0) {
            percent = 1;
        }
        var toY = from.top + (y - from.top) * percent;
        container.scrollTo(x, toY);
    }
    // animate
    function animate() {
        if (stop) {
            callback();
            return;
        }
        raf(animate);
        update();
    }
    animate();
}
